import { Flex, Select } from "antd";
import { useEffect } from "react";
import { useQuote } from "../../QuoteProvider";
import { useIsMobile } from "../../MobileBreakpointContext";
import "./quote-filters-form.css";
// @ts-ignore
import { useTranslation } from "react-i18next";

type QuoteFiltersFormProps = {
  onChangeProcedureTypeSelect: (e: any) => void;
  procedureTypeOptions: any;
  selectedProcedureType?: string;
};

const QuoteFiltersForm = ({
  onChangeProcedureTypeSelect,
  procedureTypeOptions,
  selectedProcedureType,
}: QuoteFiltersFormProps) => {
  const { setGender } = useQuote();
  const isMobile = useIsMobile();
  // @ts-ignore
  const { t } = useTranslation("quote");

  const genderOptions = [
    { label: t("procedures.female"), value: "FEMALE" },
    { label: t("procedures.male"), value: "MALE" },
    { label: t("procedures.allGenders"), value: null },
  ];

  // Auto-select all genders on mobile
  useEffect(() => {
    if (isMobile) {
      setGender(null); // All genders
    }
  }, [isMobile, setGender]);

  // On mobile, render horizontally scrolling pills instead of a select
  if (isMobile) {
    const activeValue = selectedProcedureType || "all";
    const pills = [
      { value: "all", label: t("procedures.showAll") },
      ...procedureTypeOptions,
    ];

    return (
      <div
        className="procedure-type-pills"
        role="tablist"
        aria-label={t("procedures.filterByType", {
          defaultValue: "Filter procedures by type",
        })}
      >
        <div className="procedure-type-pills-track">
          {pills.map((pill: { value: string; label: string }) => {
            const isActive = activeValue === pill.value;
            return (
              <button
                type="button"
                key={pill.value}
                role="tab"
                aria-selected={isActive}
                className={`procedure-type-pill${isActive ? " is-active" : ""}`}
                onClick={() => onChangeProcedureTypeSelect(pill.value)}
              >
                {pill.label}
              </button>
            );
          })}
        </div>
      </div>
    );
  }

  return (
    <Flex gap="small" wrap="wrap" style={{ marginBottom: "15px" }}>
      <Select
        style={{ width: "48%" }}
        options={genderOptions}
        defaultValue={"FEMALE"}
        onChange={(e: any) => {
          setGender(e);
        }}
      />
    </Flex>
  );
};

export default QuoteFiltersForm;
